export default __webpack_public_path__ + "static/media/1.fa7e7995.jpg";